import { useContext, useEffect, useState } from "react";
import {
  fetchData,
  GET_ALL_MOVIE_BY_CAT_LANG_ID,
  GET_ALL_MOVIE_CATEGORIES,
} from "../../components/Service";
import {
  Link,
  useLocation,
  useParams,
} from "react-router-dom";
import { scrollTop } from "../../components/Helper";
import MovieCard from "./partials/MovieCard";
import Select from "react-select";
import moment from "moment";
import { Context } from "../../components/Context";

const Movie = () => {
  const { lang_id } = useParams();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [cat, setCat] = useState([]);
  const [defaultCatId, setDefaultCatId] = useState();
  const [pageUrl, setPageUrl] = useState();
  const [notFound, setNotFound] = useState(false);
  const [selectedCat, setSelectedCat] = useState();
  const [context,setContext] = useContext(Context);

  const setListView = (value) => {
    setContext((prev) => ({...prev,listView:value  }))
  }

  const getAllCategories = () => {
    fetchData(GET_ALL_MOVIE_CATEGORIES, "GET", "", false, false, (res) => {
      if (res.status) {
        setCat(res?.data);
        setDefaultCatId(0);
        setSelectedCat({ label: "All", value: 0 });
      } else {
        setCat([]);
      }
    });
  };

  const getList = (langId, catId) => {
    let payload = {
      language_id: langId,
      category_id: catId,
    };
    fetchData(
      pageUrl ? pageUrl : GET_ALL_MOVIE_BY_CAT_LANG_ID,
      "POST",
      payload,
      false,
      false,
      (res) => {
        if (res.status) {
          setNotFound(false);
          setList(res?.data?.result);
        } else {
          setNotFound(true);
          setList([]);
        }
      }
    );
  };
  const refressData =()=>{
    getList(lang_id, defaultCatId);
  }

  useEffect(() => {
    scrollTop();
    if (lang_id) {
      setPageUrl();
      getList(lang_id, defaultCatId);
    }
  }, [lang_id, defaultCatId]);

  useEffect(() => {
    scrollTop();
    if (lang_id) {
      getList(lang_id, defaultCatId);
    }
  }, [pageUrl]);

  useEffect(() => {
    scrollTop();
    getAllCategories();
  }, []);

  return (
    <div class="col-lg-12">
      <div class="card card-forum">
        <div class="card-header usa-bg px-1">
          <div className="national-bg">
            <div className="row d-flex align-items-center ind1">
              <div className="col-lg-3">
                <h4 class="text-white d-flex mb-0 py-2">
                  Movies by Language {location?.state?.pageTitle}
                </h4>
              </div>
              <div className="col-lg-9 ms-auto text-start text-lg-end ">
                <Select
                  options={[
                    { label: "All", value: 0 },
                    ...(cat?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    })) || []),
                  ]}
                  value={selectedCat}
                  onChange={(selected) => {
                    setSelectedCat(selected);
                    setDefaultCatId(selected?.value);
                  }}
                  placeholder="Select category"
                  className={`selectpicker custom-react-select custom-react-select-w200 me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30`}
                  classNamePrefix="react-select"
                />
                <Link
                  to={`/movies`}
                  class="btn btn-warning btn-find font11 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-1 px-lg-2 rounded-1 height30 mb2px mt2px"
                >
                  View All
                </Link>
                {context.listView ? (
                  <>
                    <div class="list-frid-view cursor-pointer  ms-lg-1">
                      <img
                        src="/assets/images/list-active.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                    <div
                      class="list-frid-view cursor-pointer "
                      onClick={() => setListView(false)}
                    >
                      <img
                        src="/assets/images/grid-inactive.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      class="list-frid-view cursor-pointer  ms-lg-1 "
                      onClick={() => setListView(true)}
                    >
                      <img
                        src="/assets/images/list-inactive.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                    <div class="list-frid-view cursor-pointer ">
                      <img
                        src="/assets/images/grid-active.png"
                        alt="..."
                        className="me-1"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {context.listView ? (
          <div className="card-body bg-white p-1 body-minh">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr className="table-active">
                    <th scope="col">Title</th>
                    <th scope="col">Rating</th>
                    <th scope="col">Total Dislikes</th>
                    <th scope="col">Total Likes</th>

            
                  </tr>
                </thead>
                <tbody>
                  {list?.data &&
                    list?.data?.length > 0 &&
                    list?.data?.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <a
                            href={item?.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item?.name ?? "N/A"}
                          </a>
                        </td>
                        <td>{item?.rating ?? "N/A"}</td>
                        <td>{item?.total_dislikes ?? "N/A"}</td>
                        <td>{item?.total_likes ?? "N/A"}</td>
                      </tr>
                    ))}

                  {notFound && (
                    <tr>
                      <td
                        className="text-center h6 text-danger py-3"
                        colSpan={4}
                      >
                        No Records Found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {list?.data && (
              <nav className="pt-3">
                <ul className="pagination justify-content-end">
                  <li
                    className={`page-item ${
                      list.prev_page_url ? "" : "disabled"
                    }`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => setPageUrl(list.prev_page_url)}
                    >
                      <span aria-hidden="true">&laquo;</span> Previous
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      list.next_page_url ? "" : "disabled"
                    }`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => setPageUrl(list.next_page_url)}
                    >
                      Next <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
        ) : (
          <div class="card-body bg-white p-1 body-minh">
            <div className="row">
              {list?.data &&
                list?.data?.length > 0 &&
                list?.data?.map((item) => (
                  <MovieCard key={item.id} item={item} refressData={refressData} />
                ))}
              {notFound && (
                <div className="text-center h6 text-danger py-3">
                  No Records Found!
                </div>
              )}
            </div>
            {list?.data && (
              <nav className="pt-3">
                <ul className="pagination justify-content-end">
                  <li
                    className={`page-item ${
                      list.prev_page_url ? "" : "disabled"
                    }`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => setPageUrl(list.prev_page_url)}
                    >
                      <span aria-hidden="true">&laquo;</span> Previous
                    </button>
                  </li>
                  <li
                    className={`page-item ${
                      list.next_page_url ? "" : "disabled"
                    }`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={() => setPageUrl(list.next_page_url)}
                    >
                      Next <span aria-hidden="true">&raquo;</span>
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Movie;
